import { render, staticRenderFns } from "./RequestDetails.vue?vue&type=template&id=b23a9bf8&"
import script from "./RequestDetails.vue?vue&type=script&lang=js&"
export * from "./RequestDetails.vue?vue&type=script&lang=js&"
import style0 from "./RequestDetails.vue?vue&type=style&index=0&id=b23a9bf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports